module.exports = __webpack_public_path__ + "img/avatar7.847d9084.png";